export default {
  name: 'inputPopover',
  $emit: ['modelValue'],
  props: {
    modelValue: String,
    placeholder: {
      type: String,
      "default": ''
    },
    placement: {
      type: String,
      "default": 'bottom'
    },
    fieldType: {
      type: String,
      "default": 'text'
    },
    popper_class: {
      type: String,
      "default": ''
    },
    data: Array,
    attrName: {
      type: String,
      "default": 'attribute_name'
    },
    popper_extra: {
      type: String,
      "default": ''
    },
    doc_url: {
      type: String,
      "default": function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      model: this.modelValue,
      activeIndex: '0',
      visible: false
    };
  },
  watch: {
    model: function model() {
      this.$emit('modelValue', this.model);
    }
  },
  methods: {
    selectEmoji: function selectEmoji(imoji) {
      this.insertShortcode(imoji.data);
    },
    insertShortcode: function insertShortcode(codeString) {
      if (!this.model) {
        this.model = '';
      }
      this.model = codeString.replace(/param_name/, this.attrName);
      this.visible = false;
    }
  }
};